import { redirect } from '@tanstack/react-router'

import { readActiveView } from '@/features/chart-tabs/lib/tabsStorage'
import { readLastChartSymbol } from '@/features/trading-chart/lib/lastUsed'

/** The market's own index: what a member with no history opens on. */
export const DEFAULT_CHART_SYMBOL = 'NEPSE'

/**
 * The `/chart` loader: the sidebar's "Chart" row carries no symbol, so it is
 * sent to the last one charted, else NEPSE, on the tab the member left showing:
 * the Advanced screener or the New tab when it was one of those
 * (features/chart-tabs).
 *
 * No request to check the symbol: an unknown one is answered by the target
 * page's own loader (a not-found there), which is the one place that already
 * has the symbol read. Validating here would ask twice.
 *
 * `replace: true` so Back does not bounce through this segment. Always
 * throws, so `component` on the route never renders.
 */
export function loadChartRedirect(): never {
  // eslint-disable-next-line @typescript-eslint/only-throw-error
  throw redirect({
    to: '/chart/$symbol',
    params: { symbol: readLastChartSymbol() ?? DEFAULT_CHART_SYMBOL },
    search: { view: readActiveView() },
    replace: true,
  })
}
